import {
  combineReducers,
  configureStore,
  PreloadedState,
} from '@reduxjs/toolkit';
import { api } from '../api/api';
import modal from './slices/modalSlice';
import utilityValues from './slices/utilityValues';
import registration from './slices/registration';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  utilityValues,
  registration,
  modal,
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
    preloadedState,
  });

export const store = setupStore({});

// Infer the `RootState`, `AppStore` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
